
import React, { useState, useEffect } from 'react';
import './Carousel.css';

const slides = [
  {
    id: 1,
    title: "¡Haz de tu boda un recuerdo inolvidable!",
    description: "Captura cada momento mágico de tu día especial con nuestra cabina 360°. Tus invitados se divertirán y tú tendrás recuerdos únicos para toda la vida.",
    buttonText: "¡Quiero mi boda épica!",
    image: "https://cdn.abacus.ai/images/fd75dbba-7da1-4ef8-96a8-db6d7a9e7d78.png"
  },
  {
    id: 2,
    title: "¡Celebra tus XV con estilo y diversión!",
    description: "Tu fiesta de XV años será la más comentada. Nuestra cabina 360° hará que todos tus amigos quieran estar en cada video. ¡Prepárate para brillar!",
    buttonText: "¡Quiero mis XV perfectos!",
    image: "https://cdn.abacus.ai/images/b55219e6-8aee-48b6-910b-18b0b53f8821.png"
  },
  {
    id: 3,
    title: "¡Momentos únicos para tus eventos sociales!",
    description: "Cumpleaños, graduaciones, reuniones... cualquier excusa es buena para crear recuerdos increíbles. Nosotros ponemos la diversión, tú solo disfruta.",
    buttonText: "¡Llévenme la cabina!",
    image: "https://cdn.abacus.ai/images/4bdfdbd3-381c-4119-ac3c-e19bc9225022.png"
  }
];

function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleWhatsApp = (message) => {
    const phone = "525522632166";
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phone}?text=${encodedMessage}`, '_blank');
  };

  return (
    <section className="carousel">
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="carousel-overlay">
              <div className="carousel-content">
                <h1>{slide.title}</h1>
                <p>{slide.description}</p>
                <button
                  className="btn btn-primary btn-glow"
                  onClick={() => handleWhatsApp(`¡Hola! Me interesa cotizar para mi evento: ${slide.title}`)}
                >
                  {slide.buttonText}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
}

export default Carousel;
